<template>
  <div class="keyshen-page">
    <div class="ipt-top">
      <div class="key-top">
        <el-input placeholder="请输入材料名称" v-model="word">
          <el-button slot="append" color="primary" @click="serach">查询</el-button>
        </el-input>
      </div>
      <el-button @click="resetform">重置</el-button>
    </div>
    <el-table
      v-loading="listLoading"
      stripe
      style="width:100%"
      border
      :data="tableData1"
      height="650"
    >
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column prop="projectName" label="项目名称"></el-table-column>
      <el-table-column prop="name" label="材料名称 "></el-table-column>
      <el-table-column prop="category" label="材料类别"></el-table-column>
      <el-table-column prop="modes" label="援助方式" width="300"></el-table-column>
      <el-table-column prop="pageSize" label="材料页数"></el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="watch(scope.row,true)">查看</el-button>
          <el-button type="text" size="small" @click="watch(scope.row,false)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="foot-btn">
      <el-button type="primary" @click="handleput" :loading="downloadLoading">导出</el-button>
      <el-button type="primary" @click="dialogTableVisible = true">导入</el-button>
    </div>

    <!-- 弹窗 -->
    <el-dialog title="
材料关键字编辑" :visible.sync="dialogFormVisible">
      <el-form label-width="160px" label-position="left" class="key-dialog">
        <div>
          <div class="grid-content">
            <p>材料名称</p>
            <p>{{seeData.name}}</p>
          </div>
          <div class="grid-content">
            <p>材料类别</p>
            <p>{{seeData.category}}</p>
          </div>
          <div class="grid-content">
            <p>援助方式</p>
            <p>{{seeData.modes}}</p>
          </div>
        </div>
        <el-form-item v-for="(item, index) in keyList" :label="'第' + (index+1)+'页关键字'" :key="index">
          <el-input v-model="item.words" :disabled="iswatch" type="textarea" :rows="5"></el-input>
          <div class="btn-all">
            <el-button
              v-if="!iswatch"
              @click.prevent="addDomain()"
              icon="el-icon-plus"
              size="small"
              type="primary"
            ></el-button>
            <el-button
              v-if="!iswatch && index!=0"
              @click.prevent="removeDomain(index)"
              icon="el-icon-minus"
              size="small"
              type="primary"
            ></el-button>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitkey">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 关键字弹窗 -->
    <el-dialog title="关键字导入" :visible.sync="dialogTableVisible">
      <div class="importbtn">
        <el-input>
          <el-upload
            slot="append"
            class="upload-demo"
            ref="excelUp"
            name="file"
            :limit="1"
            :action="importUrl"
            :headers="{
                  'Authorization': token
                }"
            :on-exceed="handleExceed"
            :before-upload="beforeExcelUpload"
            :on-success="handleSuccess"
            :auto-upload="false"
          >
            <el-button type="primary">选择</el-button>
          </el-upload>
        </el-input>
        <el-button type="text" @click="handleput">模板下载</el-button>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelimport">取 消</el-button>
        <el-button type="primary" @click="submitimport">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  checkquery,
  checkexport,
  checkimport,
  checkupdate
} from "@/api/Materialkey";
export default {
  inject: ["reload"],
  data() {
    return {
      tableData1: [],
      listLoading: false,
      projectId: null,
      word: null,
      dialogFormVisible: false,
      iswatch: false,
      keyList: [],
      seeData: {},
      addList: [],
      downloadLoading: false, //导出按钮
      importUrl: checkimport,
      fileList: [],
      token: this.$store.getters.token,
      dialogTableVisible: false
    };
  },
  created() {
    this.projectId = this.$route.query.id * 1;

    if (this.$route.query.hasOwnProperty("word")) {
      this.word = this.$route.query.word;
      this.initData(this.word);
    } else {
      this.initData(null);
    }
  },
  methods: {
    resetform() {
      this.word = null;
      this.$router.replace({
        query: { id: this.projectId }
      });
      checkquery(this.projectId).then(res => {
        this.listLoading = false;
        this.tableData1 = res.data;
      });
    },

    initData(str) {
      this.listLoading = true;
      checkquery(this.projectId, str).then(res => {
        this.listLoading = false;
        this.tableData1 = res.data;
      });
    },
    watch(row, bol) {
      this.iswatch = bol;
      this.seeData = row;
      this.keyList = JSON.parse(row.keyword);
      this.dialogFormVisible = true;
    },
    serach() {
      this.listLoading = true;

      if (this.word) {
        checkquery(this.projectId, this.word.trim()).then(res => {
          this.listLoading = false;
          this.tableData1 = res.data;
        });
        this.$router.replace({
          query: { word: this.word.trim(), id: this.projectId }
        });
      } else {
        checkquery(this.projectId).then(res => {
          this.listLoading = false;
          this.tableData1 = res.data;
        });
        this.$router.replace({ query: { id: this.projectId } });
      }
    },
    //  导出
    handleput() {
      if (!this.tableData1.length) {
        return false;
      }
      this.downloadLoading = true;
      checkexport(this.projectId).then(res => {
        if (res.code === 20000) {
          console.log("ajhfdak", "");
          if (res.type === "application/json") {
            this.$message.error("导出失败！");
            return false;
          }

          let oMyBlob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
          });
          let url = window.URL.createObjectURL(oMyBlob);
          let alink = document.createElement("a");
          document.body.appendChild(alink);
          alink.setAttribute("style", "display: none");
          alink.setAttribute("href", url);
          alink.setAttribute("download", "审核材料关键字导出.xlsx");
          alink.click();
          document.body.removeChild(alink); // 移除元素
          window.URL.revokeObjectURL(url); // 释放blob对象
          this.downloadLoading = false;
        } else {
          this.$message.error(res.message);
          this.downloadLoading = false;
        }
      });
    },
    // 取消导入
    cancelimport() {
      this.dialogTableVisible = false;
    },
    // 确定导入
    submitimport() {
      this.$refs.excelUp.submit();
    },
    beforeExcelUpload(file) {
      // 上传前校验文件
      const isExcel =
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.name.indexOf(".xls") > 0;
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isExcel) {
        this.$message.error("上传文件只能是xls或者xlsx格式!");
      }
      if (!isLt20M) {
        this.$message.error("上传文件大小不能超过20MB!");
      }
      return isExcel && isLt20M;
    },
    // 导入
    handleSuccess(response, file, fileList) {
      console.log("response", response);
      if (!response.success) {
        this.$message.error(response.message);
      } else {
        this.$message({
          message: "导入成功",
          type: "success"
        });
      }
      this.dialogTableVisible = false;
      this.reload();
    },
    handleExceed(file, fileList) {
      this.$message.error("请先删除旧文件再上传！");
    },
    addDomain() {
      var len = this.keyList.length;
      if (len == 5) {
        return false;
      }
      this.keyList.push({ words: "", num: len + 1 });
    },
    removeDomain(index) {
      if (!this.keyList[index].words) {
        this.keyList.splice(index, 1);
      } else {
        this.$confirm("是否确定删除该页关键字?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.keyList.splice(index, 1);
          })
          .catch(() => {});
      }
    },
    submitkey() {
      if (this.iswatch) {
        this.dialogFormVisible = false;
        return false;
      }
      for (var i = 0; i < this.keyList.length; i++) {
        if (!this.keyList[i].words) {
          this.$message.error("第" + (i + 1) + "页的关键字为空");
          return false;
          break;
        }
      }
      const info = {
        projectId: this.projectId,
        configId: this.seeData.id,
        keyword: JSON.stringify(this.keyList)
      };
      checkupdate(info).then(res => {
        this.$router.replace({ query: { id: this.projectId } });
        this.word = "";
        this.initData();
        this.dialogFormVisible = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.keyshen-page {
  .ipt-top {
    height: 36px;
    display: flex;
    margin-bottom: 20px;
    justify-content: flex-end;
    .key-top {
      margin-right: 20px;
      width: 40%;
      max-width: 300px;
      min-width: 200px;
    }
  }
  .grid-content {
    display: flex;
    p {
      &:nth-child(1) {
        width: 160px;
      }
      &:nth-child(2) {
        width: 380px;
      }
    }
  }
  .btn-all {
    margin-left: 10px;
    display: inline-block;
    width: 50px;
    button {
      margin: 0px;
    }
  }
  .foot-btn {
    margin-top: 15px;
  }
}
</style>
<style lang="scss">
.keyshen-page {
  .ipt-top {
    .el-input-group__append {
      background-color: rgb(24, 144, 255);
      color: #fff;
    }
  }
  .el-dialog {
    width: 580px;
    height: 600px;
    overflow: auto;
    .key-dialog {
      label {
        font-weight: 400;
      }
      .el-textarea {
        width: 280px;
      }
    }
  }
  .importbtn {
    .el-input-group__append {
      position: relative;
      .el-upload-list {
        width: 430px;
        position: absolute;
        right: 72px;
        top: 0px;
        bottom: 0px;
        margin: auto 0;
        .el-upload-list__item {
          margin-top: 6px;
        }
      }
    }
  }
}
</style>